<template>
  <v-row
    v-if="prop != null && !isSingleInternalReference"
    class="ma-0 ml-2 pr-5 pa-0 pb-1"
    align="center"
  >
    <div v-bind:class="getClasses" class="ma-0 pa-0 pt-1">
      <v-icon size="6" class="pb-1" color="#193153">{{ icon }}</v-icon>
      <span v-html="prop" class="ml-1"></span>
      <sup
        class="vetalfa-pointer text--disabled pl-1"
        v-if="references && references.length"
        @click="setClickedReferences(references)"
        >{{ "[ref]" }}</sup
      >
      <slot></slot>
    </div>
  </v-row>
  <vetalfa-dose-card
    isCard
    v-else-if="!!isSingleInternalReference && !!references[0].dose"
    class="mb-4 mt-2 ma-0 pa-0"
    :isDrugsManagement="isAdmin"
    :prop="{
      ...this.references[0].dose,
      title: this.references[0].name,
      options: prop,
      path: this.references[0].path,
    }"
  ></vetalfa-dose-card>
  <vetalfa-reference-card
    v-else
    :reference="references[0]"
  ></vetalfa-reference-card>
</template>

<style>
.section-item {
  background-color: transparent;
  width: 100%;
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
.section-item-result {
  background-color: white;
  width: 100%;
  font-size: 18px;
  font-weight: 0;
  color: #393a3a;
}
.section-item-border {
  border-top: 0.5px dashed rgb(57, 58, 58, 0.4);
}
</style>

<script>
import { mdiCircle } from "@mdi/js";
import { mapMutations } from "vuex";
export default {
  name: "SectionItem",
  props: {
    prop: {
      type: String,
    },
    index: {
      type: Number,
      default: 0,
    },
    result: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasMargins: {
      type: Boolean,
      default: true,
      required: false,
    },
    references: {
      type: Array,
      default: null,
      required: false,
    },
  },
  computed: {
    getClasses() {
      let classes = this.index > 0 ? "section-item-border " : "";
      classes += this.hasMargins ? " ml-4 " : "";
      return classes + (this.result ? "section-item-result" : "section-item");
    },
    isSingleInternalReference() {
      return (
        !!this.references &&
        this.references.length == 1 &&
        this.references[0].type == 1
      );
    },
    isAdmin() {
      return process.env.VUE_APP_ENV === "admin";
    },
  },
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      icon: mdiCircle
    };
  },
};
</script>